import ProtectedEnvironmentsForm from './ProtectedEnvironmentsForm';

export default ProtectedEnvironmentsForm;
